import React from 'react';
import { ButtonToolbar, Button } from 'react-bootstrap';

const SubscriptionMethod = props => {
  const web = props.subscription_method === 'web';
  const mobile = props.subscription_method === 'mobile';

  return (
    <div className="subscription-field">
      <span className="current-method">Current Method</span>
      <ButtonToolbar>
        <Button onClick={props.handleSubscriptionMethodChange} bsStyle={web ? 'primary' : null} name="web">
          Web
        </Button>
        <Button onClick={props.handleSubscriptionMethodChange} bsStyle={mobile ? 'primary' : null} name="mobile">
          Mobile
        </Button>
      </ButtonToolbar>
      {mobile && (
        <span className="install-link-at">
          {/*Install our app available at <a href="#">link</a> to use the mobile subscription method.*/}
          <a
            href="https://itunes.apple.com/us/app/presence-walk-with-god/id1400174335?l=ru&ls=1&mt=8"
            target="_blank"
            style={{ color: '#959595' }}
          >
            Please download the Presence App from the App Store.
          </a>
        </span>
      )}
    </div>
  );
};

export default SubscriptionMethod;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Schedule/SubscriptionMethod.js